import React from 'react';
import { JuniorLayout } from '../../components/layout/JuniorLayout';
import { MelodiaBuilder } from '../../components/constructorMelodias/MelodiaBuilder';
import { RequireJuniorSession } from '../../components/auth/RequireJuniorSession';

function ConstructorMelodiasPageInner() {
  return (
    <JuniorLayout immersive>
      <MelodiaBuilder />
    </JuniorLayout>
  );
}

export default function ConstructorMelodiasPage() {
  return (
    <RequireJuniorSession>
      <ConstructorMelodiasPageInner />
    </RequireJuniorSession>
  );
}
